<template>
<div class="social-media">
  <img :src="facebook" class="social-media-icon animation" @click="goTo('facebook')" />
  <img :src="instagram" class="social-media-icon animation" @click="goTo('instagram')" />
  <img :src="linkedin" class="social-media-icon animation" @click="goTo('linkedin')" />
</div>
</template>
<script>
export default {
  data () {
    return {
      facebook: require('@/assets/facebook.png'),
      linkedin: require('@/assets/linkedin.png'),
      instagram: require('@/assets/instagram.png')
    }
  },
  methods: {
    goTo (page) {
      let url = {
        facebook: 'https://www.facebook.com/rideqab/',
        linkedin: 'https://www.linkedin.com/company/rideq/',
        instagram: 'https://www.instagram.com/rideq.se/'
      }[page]

      window.open(url, 'blank')
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .social-media {
    width: auto;
    max-width: 200px;
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 50px;
  }

  .social-media-icon {
    height: 30px;
    width: 30px;
    margin-right: 10px;
    cursor: pointer;
    border-radius: 5px;
  }
</style>
